import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import ChangePassword from '../profile/components/ChangePassword';
import TwoFactorForm from '../profile/components/TwoFactorForm';

const UserSecurityPage = (): ReactElement => (
    <>
        <HeadTag title="User Security" />
        <Box className="flex-column p-10">
            <ChangePassword />
            <TwoFactorForm />
        </Box>
    </>
);

export default UserSecurityPage;
